import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	runAsUserMisconfigured: {
		id: 'servicedesk.automation.summary.misconfigured-message.run-as-user-misconfigured',
		defaultMessage: 'The selected default user is not able to run automation rules.',
		description: '',
	},
	selectAnotherUser: {
		id: 'servicedesk.automation.summary.misconfigured-message.select-another-user',
		defaultMessage: 'Select another user',
		description: '',
	},
});
